import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "envelope",
  "use": "envelope-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"envelope\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 4c0-1.244.758-2 2-2h12c1.242 0 2 .755 2 2v8c0 1.244-.758 2-2 2H2c-1.242 0-2-.755-2-2V4zm1 0v8c0 .418.588 1 1 1h12c.412 0 1-.582 1-1V4c0-.418-.588-1-1-1H2c-.412 0-1 .582-1 1zm2.6.7a.5.5 0 01.7-.1L8 7.375 11.7 4.6a.5.5 0 01.6.8l-4 3a.5.5 0 01-.6 0l-4-3a.5.5 0 01-.1-.7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol